import { AdaptedGroup, ErrorsByGroupId, GroupEdition, GroupEditionErrors } from "../models";
import isHardError from "./isHardError";

/**
 * Returns `true` when at least one edition exists and every edited group has
 * at least one hard error. Groups present in `byGroupId` but absent from
 * `errorsByGroupId` are treated as having no errors, so any single saveable
 * edition is enough to make the result `false`.
 *
 * @param byGroupId       Editions made by the user, keyed by group id.
 * @param errorsByGroupId Validation errors per edited group.
 *
 * @returns `true` if there is something edited and every edited group is blocked
 *          by a hard error; `false` if nothing was edited or at least one
 *          edition is still saveable.
 */
const allEditionsWithHardErrors = (
  byGroupId: Record<AdaptedGroup["id"], GroupEdition>,
  errorsByGroupId: ErrorsByGroupId,
): boolean => {
  const editedGroupIds = Object.keys(byGroupId ?? {});

  if (editedGroupIds.length === 0) return false;

  return editedGroupIds.every(groupId => {
    const errors = errorsByGroupId?.[groupId] ?? {};
    return (Object.keys(errors) as Array<keyof GroupEditionErrors>).some(isHardError);
  });
};

export default allEditionsWithHardErrors;
